import PropTypes from "prop-types";
// @mui
// import { Box, LinearProgress } from '@mui/material';
import { styled } from "@mui/material/styles";

// ----------------------------------------------------------------------

const RootStyle = styled("div")(({ theme }) => ( {
    right: 0,
    bottom: 0,
    zIndex: 99999,
    width: "100%",
    height: "100%",
    position: "fixed",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: theme.palette.background.default,

    "@keyframes animation-loader-44": {
        "0%": {
            boxShadow: "14px 0 0 -2px,  38px 0 0 -2px,    -14px 0 0 -2px,  -38px 0 0 -2px"
        },
        "25%": {
            boxShadow: "14px 0 0 -2px,  38px 0 0 -2px,    -14px 0 0 -2px,  -38px 0 0 2px"
        },
        "50%": {
            boxShadow: "14px 0 0 -2px,  38px 0 0 -2px,    -14px 0 0 2px,  -38px 0 0 -2px"
        },
        "75%": {
            boxShadow: "14px 0 0 2px,  38px 0 0 -2px,    -14px 0 0 -2px,  -38px 0 0 -2px"
        },
        "100%": {
            boxShadow: "14px 0 0 -2px,  38px 0 0 2px,    -14px 0 0 -2px,  -38px 0 0 -2px"
        }
    },

    "& .loader-44": {
        width: "12px",
        height: "12px",
        borderRadius: "50%",
        display: "inline-block",
        position: "relative",
        color: "primary.main",
        animation: "animation-loader-44 1.5s linear infinite"
    }
} ));

// ----------------------------------------------------------------------

export default function LoadingScreen({ sx, ...other }) {
    // return (
    //     <Box
    //         sx={{
    //             px: 5,
    //             width: 1,
    //             flexGrow: 1,
    //             minHeight: 1,
    //             display: 'flex',
    //             alignItems: 'center',
    //             justifyContent: 'center',
    //             ...sx,
    //         }}
    //         {...other}
    //     >
    //         <LinearProgress color="inherit" sx={{ width: 1, maxWidth: 360 }}/>
    //     </Box>
    // );

    return (
        <RootStyle {...other}>
            <div className="loader-44"/>
        </RootStyle>
    )
}

LoadingScreen.propTypes = {
    sx: PropTypes.object
};
